import React from "react";
import Select from "react-select";

export default function SelectField({ field, value, onChange }) {
  const opts = field.options || [];
  const selected = opts.find(o => o.value === value) || null;
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <Select
        className="mp-select"
        options={opts}
        value={selected}
        isClearable={!field.required}
        onChange={o => onChange(field.name, o ? o.value : null)}
      />
    </div>
  );
}
